module.exports = __webpack_public_path__ + "static/media/user.775b91d4.jpg";